import {
  useEffect,
  useState,
  type ChangeEvent,
  type Dispatch,
  type SetStateAction,
} from 'react';
import cx from 'classnames';
import styles from '@redturtle/qubicaamf-theme/components/Header/styles.module.css';
import { NavLink, useHistory } from 'react-router-dom';

import SearchIcon from '@redturtle/qubicaamf-theme/components/Icons/SearchIcon';
import { Button, Form, Input } from 'react-aria-components';
import { defineMessages, useIntl } from 'react-intl';
import { CloseIcon } from '@plone/components';

export default function SearchContact({
  searchIsVisible,
  setSearchIsVisible,
}: {
  searchIsVisible: boolean;
  setSearchIsVisible: Dispatch<SetStateAction<boolean>>;
}) {
  const intl = useIntl();
  const history = useHistory();

  const [searchText, setSearchText] = useState<string>('');

  const onChangeText = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };
  const onSubmit = (event) => {
    history.push(`/search?SearchableText=${encodeURIComponent(searchText)}`);
    setSearchText('');

    event.preventDefault();
  };

  useEffect(() => {
    setSearchIsVisible(false);
    setSearchText('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location.pathname]);
  return (
    <>
      <Form
        onSubmit={onSubmit}
        action={`/search?SearchableText=${encodeURIComponent(searchText)}`}
      >
        <div
          className={cx(styles.tools_search_wrapper, {
            [styles.setHeight]: searchIsVisible,
          })}
        >
          {searchIsVisible && (
            <div className={styles.searchInput}>
              <Input
                aria-label={intl.formatMessage(messages.search_bar)}
                placeholder={intl.formatMessage(messages.search_bar)}
                onChange={(e) => onChangeText(e)}
              />
            </div>
          )}
          <div className={styles.search_icon}>
            <Button
              onPress={() => {
                setSearchIsVisible(!searchIsVisible);
              }}
              className={styles.searchButton}
            >
              {searchIsVisible ? <CloseIcon /> : <SearchIcon />}
            </Button>
          </div>
          <div className={styles.contact_us}>
            <NavLink to="/contact">
              {intl.formatMessage(messages.contact_us)}
            </NavLink>
          </div>
        </div>
      </Form>
    </>
  );
}

const messages = defineMessages({
  search_bar: {
    id: 'search_bar',
    defaultMessage: 'Search',
  },
  contact_us: {
    id: 'contact_us',
    defaultMessage: 'Contact us',
  },
});
